import Vue from 'vue';
export function useEmitter() {
    const internalInstance = new Vue();
    // @ts-ignore
    const emitter = internalInstance.$emitter;
    return emitter;
}
